module.exports = __webpack_public_path__ + "static/EU-flag-red-a5388bfb8c81717f38d920da6a23496c.jpg";